module.exports = __webpack_public_path__ + "d923e53579cdbe3762069b874f3f0ced.fbx";